import { Reducer, Action } from "redux";
import { ClientSetupState, KnownOrderPadAction, unloadedClientSetupState } from ".";

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const reducer: Reducer<ClientSetupState> = (state: ClientSetupState | undefined, incomingAction: Action): ClientSetupState => {
  if (state === undefined) {
    return unloadedClientSetupState;
  }

  const action = incomingAction as KnownOrderPadAction;
  switch (action.type) {
    case "SET_CLIENT_PARAMS":
      return {
        params: action.params,
      }
  }

  return state;
};
